// 
import { initializeApp } from "firebase/app";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyCGEwb40W-PuAYQKgecfjsgHn_wIGM2Q0k",
    authDomain: "meatery-74d44.firebaseapp.com",
    projectId: "meatery-74d44",
    storageBucket: "meatery-74d44.firebasestorage.app",
    messagingSenderId: "577754291522",
    appId: "1:577754291522:web:6cccf0ca0fe160d7dabcdb",
    measurementId: "G-M86JT1LYTQ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);


export { app };
